/* Odds Comfort: product behaviour. Used by the product page and by quick view via Odds.initProduct(root). */
(function () {
  'use strict';
  var Odds = window.Odds; if (!Odds) return;
  var $ = Odds.$, $$ = Odds.$$;

  function initProduct(root) {
    if (!root || root.__odds) return; root.__odds = true;
    var jsonEl = $('[data-product-json]', root); if (!jsonEl) return;
    var P = JSON.parse(jsonEl.textContent);
    var isQuick = root.hasAttribute('data-quick');
    var form = $('[data-product-form]', root);
    var idInput = $('[data-variant-input]', root);
    var qtyInput = $('[data-qty-input]', root);
    var addBtn = $('[data-add]', root);
    var selected = (P.variants.filter(function (v) { return v.id === P.selected; })[0] || P.variants[0]).options.slice();

    /* ---------- variant resolution ---------- */
    function find(opts) { return P.variants.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0]; }
    function closest(changedIdx, value) {
      // among variants that have the clicked value, pick the one sharing the most other selections
      var best = null, bs = -1;
      P.variants.forEach(function (v) {
        if (v.options[changedIdx] !== value) return;
        var s = 0; v.options.forEach(function (o, i) { if (i !== changedIdx && o === selected[i]) s += 2; });
        if (v.available) s += 1;
        if (s > bs) { bs = s; best = v; }
      });
      return best;
    }
    function current() { return find(selected); }

    function paint(v, scroll) {
      if (!v) return;
      selected = v.options.slice();
      $$('[data-option-input]', root).forEach(function (inp) {
        var i = Number(inp.getAttribute('data-option-index'));
        inp.checked = inp.value === selected[i];
        var lab = inp.closest('label'); if (lab) lab.classList.toggle('is-on', inp.checked);
        // availability hint for the value given the other current selections
        var test = selected.slice(); test[i] = inp.value;
        var vv = find(test);
        if (lab) lab.classList.toggle('is-soldout', !!vv && !vv.available);
        if (lab) lab.classList.toggle('is-missing', !vv);
      });
      $$('[data-option-label]', root).forEach(function (el) { el.textContent = selected[Number(el.getAttribute('data-option-label'))]; });
      if (idInput) idInput.value = v.id;
      // price
      var now = $('[data-price-now]', root), was = $('[data-price-was]', root), pair = $('[data-price-pair]', root), save = $('[data-price-save]', root);
      if (now) now.textContent = Odds.money(v.price, true);
      if (was) { was.hidden = !(v.compare && v.compare > v.price); was.textContent = v.compare ? Odds.money(v.compare, true) : ''; }
      if (save) { var sv = v.compare && v.compare > v.price ? v.compare - v.price : 0; save.hidden = !sv; save.textContent = sv ? Odds.t('save_amount', { amount: Odds.money(sv, true) }) : ''; }
      if (pair) { var n = v.pairs || P.pairs || 1; pair.textContent = Odds.t('per_pair', { price: Odds.money(Math.round(v.price / n), true) }); }
      var sku = $('[data-sku]', root); if (sku) sku.textContent = v.sku || '';
      // availability
      var label = $('[data-add-label]', root);
      if (addBtn) { addBtn.disabled = !v.available; if (label) label.textContent = v.available ? Odds.t('add_to_bag') : Odds.t('sold_out'); }
      // pack-size dependent copy: per-pair upgrade hint and heel tab note
      var heel = $('[data-heel-note]', root); if (heel) heel.hidden = selected.indexOf('Heel tab') < 0 && selected.indexOf('بلسان خلفي') < 0;
      // sticky bar
      var sp = $('[data-sticky-price]', root); if (sp) sp.textContent = Odds.money(v.price, true);
      var sl = $('[data-sticky-variant]', root); if (sl) sl.textContent = P.variants.length > 1 ? v.title : '';
      var sb = $('[data-sticky-add]', root); if (sb) { sb.disabled = !v.available; sb.textContent = v.available ? Odds.t('add_to_bag') : Odds.t('sold_out'); }
      // gallery
      if (scroll !== false && v.media) goToMedia(v.media);
      // URL (product page only)
      if (!isQuick && P.variants.length > 1 && window.history && history.replaceState) {
        var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
      }
      Odds.emit('product:variant', { variant: v, root: root });
    }

    $$('[data-option-input]', root).forEach(function (inp) {
      inp.addEventListener('change', function () {
        var i = Number(inp.getAttribute('data-option-index'));
        var test = selected.slice(); test[i] = inp.value;
        paint(find(test) || closest(i, inp.value));
      });
    });

    /* ---------- quantity ---------- */
    function setQty(n) { n = Math.max(1, Math.min(99, n)); if (qtyInput) qtyInput.value = n; var d = $('[data-qty-dec]', root); if (d) d.disabled = n <= 1; }
    var dec = $('[data-qty-dec]', root), inc = $('[data-qty-inc]', root);
    if (dec) dec.addEventListener('click', function () { setQty(Number(qtyInput.value) - 1); });
    if (inc) inc.addEventListener('click', function () { setQty(Number(qtyInput.value) + 1); });
    if (qtyInput) qtyInput.addEventListener('change', function () { setQty(Number(qtyInput.value) || 1); });

    /* ---------- add to bag ---------- */
    function submit(e) {
      if (e) e.preventDefault();
      var v = current(); if (!v || !v.available) return;
      var btns = [addBtn, $('[data-sticky-add]', root)].filter(Boolean);
      btns.forEach(function (b) { b.classList.add('is-loading'); });
      var items = [{ id: v.id, quantity: Number(qtyInput ? qtyInput.value : 1) || 1 }];
      var props = {};
      $$('[data-line-prop]', root).forEach(function (el) { if (el.value) props[el.getAttribute('data-line-prop')] = el.value; });
      if (Object.keys(props).length) items[0].properties = props;
      if (isQuick) { var m = $('#quick-view'); if (m) Odds.overlay.close(m, true); }
      Odds.cart.add(items, { popup: true }).then(function () {
        btns.forEach(function (b) { b.classList.remove('is-loading'); });
        var label = $('[data-add-label]', root); if (label) { label.textContent = Odds.t('added'); setTimeout(function () { label.textContent = Odds.t('add_to_bag'); }, 1800); }
      }).catch(function () { btns.forEach(function (b) { b.classList.remove('is-loading'); }); });
    }
    if (form) form.addEventListener('submit', submit);
    var stickyAdd = $('[data-sticky-add]', root); if (stickyAdd) stickyAdd.addEventListener('click', submit);

    /* ---------- gallery ---------- */
    var track = $('[data-slides]', root), slides = $$('[data-slide]', root), thumbs = $$('[data-thumb]', root);
    function indexOfMedia(id) { for (var i = 0; i < slides.length; i++) if (slides[i].getAttribute('data-media-id') === String(id)) return i; return -1; }
    function goTo(i, smooth) {
      if (!track || i < 0 || i >= slides.length) return;
      try { slides[i].scrollIntoView({ behavior: smooth === false || Odds.reduced ? 'auto' : 'smooth', inline: 'start', block: 'nearest' }); } catch (e) { track.scrollLeft = slides[i].offsetLeft; }
      mark(i);
    }
    function goToMedia(id) { var i = indexOfMedia(id); if (i > -1) goTo(i); }
    function mark(i) {
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); if (k === i) { var s = t.parentNode; if (s && s.scrollTo && s.scrollWidth > s.clientWidth) { try { s.scrollTo({ left: t.offsetLeft - s.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' }); } catch (e) { /* ignore */ } } } });
      var c = $('[data-gallery-count]', root); if (c) c.textContent = (i + 1) + ' / ' + slides.length;
      root.__slide = i;
    }
    if (track && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting && en.intersectionRatio > 0.6) mark(slides.indexOf(en.target)); }); }, { root: track, threshold: [0.6] });
      slides.forEach(function (s) { io.observe(s); });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    var prev = $('[data-gallery-prev]', root), next = $('[data-gallery-next]', root);
    if (prev) prev.addEventListener('click', function () { goTo(Math.max(0, (root.__slide || 0) - 1)); });
    if (next) next.addEventListener('click', function () { goTo(Math.min(slides.length - 1, (root.__slide || 0) + 1)); });
    // pack chips: show a single pair
    $$('[data-pair-chip]', root).forEach(function (c) { c.addEventListener('click', function () { goToMedia(c.getAttribute('data-media-id')); if (window.innerWidth < 900) { track && track.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } }); });
    // hover zoom (fine pointers)
    if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches && !isQuick) {
      slides.forEach(function (s) {
        var img = $('img', s); if (!img) return;
        s.addEventListener('mousemove', function (e) { var r = s.getBoundingClientRect(); img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%'; s.classList.add('zooming'); });
        s.addEventListener('mouseleave', function () { s.classList.remove('zooming'); });
      });
    }
    // lightbox
    slides.forEach(function (s, i) { var z = $('[data-zoom]', s); if (z) z.addEventListener('click', function () { openLightbox(i); }); });
    function openLightbox(i) {
      var lb = document.createElement('div'); lb.className = 'lb modal on'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true');
      var cur = i;
      lb.innerHTML = '<button class="icon-btn lb-x" type="button" aria-label="' + Odds.t('close') + '"><svg class="icon" aria-hidden="true"><use href="#i-x"/></svg></button><button class="icon-btn lb-prev" type="button" aria-label="' + Odds.t('previous') + '"><svg class="icon rtl-flip" aria-hidden="true"><use href="#i-left"/></svg></button><button class="icon-btn lb-next" type="button" aria-label="' + Odds.t('next') + '"><svg class="icon rtl-flip" aria-hidden="true"><use href="#i-right"/></svg></button><div class="lb-stage"><img alt=""></div><div class="lb-count"></div>';
      document.body.appendChild(lb); document.body.classList.add('lock');
      function show(n) { cur = (n + slides.length) % slides.length; var src = slides[cur].getAttribute('data-large'); $('img', lb).src = src; $('img', lb).alt = slides[cur].getAttribute('data-alt') || ''; $('.lb-count', lb).textContent = (cur + 1) + ' / ' + slides.length; }
      function close() { lb.remove(); document.body.classList.remove('lock'); document.removeEventListener('keydown', key); goTo(cur, false); }
      function key(e) { if (e.key === 'Escape') close(); else if (e.key === 'ArrowRight') show(cur + (Odds.rtl ? -1 : 1)); else if (e.key === 'ArrowLeft') show(cur + (Odds.rtl ? 1 : -1)); }
      $('.lb-x', lb).addEventListener('click', close); $('.lb-prev', lb).addEventListener('click', function () { show(cur - 1); }); $('.lb-next', lb).addEventListener('click', function () { show(cur + 1); });
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target.classList.contains('lb-stage')) close(); });
      document.addEventListener('keydown', key);
      var tx = null; lb.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', function (e) { if (tx == null) return; var d = e.changedTouches[0].clientX - tx; if (Math.abs(d) > 50) show(cur + (d < 0 ? 1 : -1)); tx = null; });
      show(i); $('.lb-x', lb).focus();
    }

    /* ---------- sticky add to bag ---------- */
    var sticky = $('[data-sticky]', root);
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      var io2 = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          var below = en.boundingClientRect.top < 0;
          var show = !en.isIntersecting && below;
          sticky.classList.toggle('on', show); document.body.classList.toggle('has-sticky-atc', show);
        });
      });
      io2.observe(addBtn);
    }

    /* ---------- bought-together bundle ---------- */
    var bundle = $('[data-bundle]', root);
    if (bundle) {
      var boxes = $$('[data-bundle-item]', bundle), totalEl = $('[data-bundle-total]', bundle), countEl = $('[data-bundle-count]', bundle), addAll = $('[data-bundle-add]', bundle);
      var calc = function () {
        var sum = 0, n = 0, cur = current();
        boxes.forEach(function (b) {
          var on = b.checked; b.closest('.bun-item').classList.toggle('off', !on);
          if (!on) return; n++;
          sum += b.hasAttribute('data-main') ? (cur ? cur.price : 0) : Number(b.getAttribute('data-price'));
        });
        if (totalEl) totalEl.textContent = Odds.money(sum, true);
        if (countEl) countEl.textContent = n;
        if (addAll) addAll.disabled = n < 1;
      };
      boxes.forEach(function (b) { b.addEventListener('change', calc); });
      Odds.on('product:variant', function (d) { if (d.root === root) { var m = $('[data-bundle-main-price]', bundle); if (m) m.textContent = Odds.money(d.variant.price, true); calc(); } });
      calc();
      if (addAll) addAll.addEventListener('click', function () {
        var v = current(); var items = [];
        boxes.forEach(function (b) { if (!b.checked) return; if (b.hasAttribute('data-main')) { if (v && v.available) items.push({ id: v.id, quantity: 1 }); } else { items.push({ id: Number(b.getAttribute('data-variant')), quantity: 1 }); } });
        if (!items.length) return; addAll.classList.add('is-loading');
        Odds.cart.add(items, { popup: false, open: true }).then(function () { addAll.classList.remove('is-loading'); }).catch(function () { addAll.classList.remove('is-loading'); });
      });
    }

    if (Odds.paintDelivery) Odds.paintDelivery(root);

    paint(current() || P.variants[0], false);
    if (!isQuick && Odds.brain) Odds.brain.track('view', { h: P.handle });
    Odds.emit('product:ready', { root: root });
  }

  Odds.initProduct = initProduct;
  function boot() { $$('[data-product-root]').forEach(function (r) { if (!r.closest('#quick-view')) initProduct(r); }); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
